module.exports = __webpack_public_path__ + "img/datensicherung.0864e41b.svg";